import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { ApiErrorHandlerService } from "../../utils/api-error-handler/api-error-handler.service";
import { IgnoredFaultCode, IgnoredFaultCodePayload } from "../../../models/api/fault/ignoredFaultCode";

@Injectable({
  providedIn: "root",
})
export class IgnoredFaultService {
  private http = inject(HttpClient);
  private apiErrorHandler = inject(ApiErrorHandlerService);

  /**
   * Gets list of all ignored faults
   * @returns An array of all ignored faults
   */
  public getIgnoredFaults() {
    return this.http
      .get<IgnoredFaultCode[]>(`${environment.baseUrlV2}/ignoredFault`)
      .pipe(this.apiErrorHandler.handle("ignored_fault"));
  }

  /**
   * Adds the provided fault to the ignore list
   * @param fault The fault to add to the ignore list
   * @returns An observable that emits a success response if addition was successfull and null if an error occured
   */
  public addIgnoredFault(fault: IgnoredFaultCodePayload) {
    return this.http
      .post(`${environment.baseUrlV2}/ignoredFault`, fault)
      .pipe(this.apiErrorHandler.handle("ignored_fault", null));
  }

  /**
   * Updates an entry on the list with provided id with given data
   * @param faultData The fault data to update the entry with
   * @param id The id of the entry to update
   * @returns An observable that emits a success response if update was successfull and null if an error occured
   */
  public updateIgnoredFault(faultData: IgnoredFaultCodePayload, id: string) {
    return this.http
      .put(`${environment.baseUrlV2}/ignoredFault/${id}`, faultData)
      .pipe(this.apiErrorHandler.handle("ignored_fault", null));
  }

  /**
   * Removes the entry with given id from the list
   * @param id The id of the entry to delete
   * @returns An observable that emits a success response if deletion was successfull and null if an error occured
   */
  public deleteIgnoredFault(id: string) {
    return this.http
      .delete(`${environment.baseUrlV2}/ignoredFault/${id}`)
      .pipe(this.apiErrorHandler.handle("ignored_fault", null));
  }
}
